import { render, staticRenderFns } from "./Freshworks.vue?vue&type=template&id=a6823856"
import script from "./Freshworks.vue?vue&type=script&lang=js"
export * from "./Freshworks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports